module.exports = __webpack_public_path__ + "static/media/education.3bf37355.jpg";